import React, { useMemo } from 'react';
import { Link } from 'react-router-dom';
import StoreLayout from './StoreLayout';
import { useTopBrands } from './catalogApi';
import { BrandTiles } from './MegaMenu';
import { brandLink, useDocumentTitle } from './retailUtils';

const ALL_BRANDS = 500;
const FEATURED = 12;

/** /brands — the header's "All brands A–Z": the biggest brands as logo tiles, then every brand
 *  in the store grouped by first letter, each opening the listing filtered to it. */
export default function StoreBrandsPage() {
  useDocumentTitle('Brands');
  const brands = useTopBrands(ALL_BRANDS);

  const groups = useMemo(() => {
    const byLetter = new Map();
    [...brands].sort((a, b) => a.brandName.localeCompare(b.brandName, 'en', { sensitivity: 'base' })).forEach(b => {
      const first = b.brandName.trim().charAt(0).toUpperCase();
      const letter = /[A-Z]/.test(first) ? first : '#';
      if (!byLetter.has(letter)) byLetter.set(letter, []);
      byLetter.get(letter).push(b);
    });
    return [...byLetter.entries()].sort(([a], [b]) => (a === '#') - (b === '#') || a.localeCompare(b));
  }, [brands]);

  return (
    <StoreLayout>
      <div className="rt-plp-head">
        <h1 className="rt-display">Brands</h1>
        {brands.length > 0 && <p className="rt-count" style={{ textAlign: 'left' }}>{brands.length} brands</p>}
      </div>

      {brands.length === 0 ? (
        <p className="rt-count" style={{ textAlign: 'left' }}>Loading brands…</p>
      ) : (
        <>
          <section className="sf-brands-featured" aria-label="Top brands">
            <BrandTiles brands={brands.slice(0, FEATURED)} />
          </section>

          <nav className="sf-az-index" aria-label="Jump to letter">
            {groups.map(([letter]) => <a key={letter} href={`#brands-${letter}`}>{letter}</a>)}
          </nav>

          <div className="sf-az">
            {groups.map(([letter, list]) => (
              <section key={letter} id={`brands-${letter}`} className="sf-az-group" aria-labelledby={`brands-h-${letter}`}>
                <h2 id={`brands-h-${letter}`}>{letter}</h2>
                <ul>
                  {list.map(b => (
                    <li key={b.brandName}>
                      <Link to={brandLink(b.brandName)}>{b.brandName}</Link>
                      <span className="rt-mega-count">{b.productCount}</span>
                    </li>
                  ))}
                </ul>
              </section>
            ))}
          </div>
        </>
      )}
    </StoreLayout>
  );
}
